import store from '@/store';
import PlaceHolder from "./PlaceHolder";
import defaultUser from "@/module_user/defaultUser.json";

const APP_NAME = 'EliteFit.AI - ';

const routes = [
    //  routes only for internal testing
    {
        path: "/test",
        component: PlaceHolder,
        children: [
            {
                path: 'rep-workout',
                component: () => import("@/module_user/views/RepWorkout"),
                name: "TestRepWorkout"
            },
            {
                path: 'rep-end-workout',
                component: () => import("@/module_user/views/RepEndWorkout"),
                name: "TestRepEndWorkout"
            },
            {
                path: "treatment",
                component: () => import("@/module_b2b_users/views/TreatmentPlan"),
                name: "TestTreatmentPlan"
            },
            {
                path: 'toast',
                component: () => import('@/module_user/components/notification_center/NotificationCenter'),
                name: "TestNotice"
            },
            {
                path: 'webcam',
                component: () => import('@/module_user/components/workout/WorkoutWebCam'),
                name: "TestWebCam"
            },
            {
                path: 'player',
                component: () => import('@/module_user/components/videoplayer/VideoPlayer'),
                name: "TestVideoPlayer"
            },
            {
                path: 'split-window',
                component: () => import('@/module_user/components/workout/WorkoutSplitWindow'),
                name: "TestSplitWindow"
            },
            {
                path: 'notice-center',
                component: () => import('@/module_user/components/notification_center/NotificationCenter'),
                name: "TestNotificationCenter"
            },
            {
                path: 'controls',
                component: () => import('@/module_user/components/workout/desktop/DesktopControl'),
                name: "TestControls"
            },
            {
                path: 'workout-ui',
                component: () => import('@/module_user/components/workout/desktop/DesktopWorkoutUI'),
                name: "TestDesktopWorkoutUI"
            },
            {
                path: 'workout/:tenant',
                component: () => {
                    return import('@/module_testing/views/HoldPoseWorkout');
                },
                beforeEnter: checkUserLogin,
                props: route => ({ id: route.query.id, tryNow: false, withEFTech: 1, withAssist: 0, poseBy:"BP", showIntro : route.query.showIntro || false }),
                name: "workout",
            },
            {
                path: 'ios',
                component: () => {
                    return import('@/module_testing/views/TestWorkout');
                },
                beforeEnter: checkUserLogin,
            },
            {
                path: "discover",
                component: () => import("@/module_user/views/Discover"),
                name: "TestDiscover",
            },
            {
                path: "tenant/:tenantId",
                component: () => import("@/module_user/views/TenantProfile"),
                name: "TestTenantProfile",
            },
            {
                path: "assignment",
                component: () => import("@/module_dashboard/views/Video-Management/AssignProgramChallenge"),
                name: "ProgramChallengeAssignment"
            },
            {
                path: "create-assign/:id?",
                component: () => import("@/module_dashboard/views/Video-Management/CreateAssignProgram"),
                name: "TestCreateAssignProgram"
            }
        ]
    },
    // demo routes
    {
        path: '/demo/tracking',
        component: () => import('@/module_user/views/DemoTracking'),
        name: "DemoTracking"
    },
    {
        path: '/demo/face-compare',
        component: () => import('@/module_user/views/DemoFaceComparison'),
        name: "DemoFaceComparison"
    },
    // {
    //   path: '/demo/workout/:tenant',
    //   component: () => {
    //     return import('./views/DemoWorkout.vue');
    //   },
    //   beforeEnter: checkUserLogin,
    //   props: route => ({ id: route.query.id, tryNow: false, withEFTech: 1, withAssist: 0, poseBy:"BP", showIntro : route.query.showIntro || false }),
    //   name: "DemoWorkout",
    // },
    {
        path: '/demo/videoplayer',
        component: () => import('@/module_user/components/DemoVideoPlayer.vue'),
        name: "DemoVideoPlayer"
    },
    // social routes
    {
        path: '/test/social/post',
        component: () => import('@/module_testing/Post'),
        name: "TestSocialPost"
    },
    {
        path: '/test/social/add-comment',
        component: () => import('@/module_social/components/post/PostAddComment'),
        name: "TestingAddComment"
    },
    {
        path: '/test/social/post-actions',
        component: () => import('@/module_social/components/post/PostActions'),
        name: "TestingPostActions"
    },
    {
        path: '/test/social/single-comment',
        component: () => import('@/module_social/components/post/Comment'),
        name: "TestingSingleComment"
    },
    {
        path: '/test/social/comments',
        component: () => import('@/module_social/components/post/Comments'),
        name: "TestingComments"
    },
    {
        path: '/test/social/post-header',
        component: () => import('@/module_social/components/post/PostHeader'),
        name: "TestingPostHeader"
    },
    {
        path: '/test/social/post-description',
        component: () => import('@/module_social/components/post/PostDescription'),
        name: "TestingPostDescription"
    },
    {
        path: '/test/social/post-carousel',
        component: () => import('@/module_social/components/post/PostCarousel'),
        name: "TestingPostCarousel"
    },
    {
        path: '/test/social/post-desktop',
        component: () => import('@/module_social/components/post/desktop/Post'),
        name: "TestingPostDesktop"
    },
    {
        path: '/test/social/post-mobile',
        component: () => import('@/module_social/components/post/mobile/Post'),
        name: "TestingPostMobile"
    },
    {
        path: '/test/social/popup',
        component: () => import('@/module_social/components/Popup'),
        name: "TestingPopup"
    },
    {
        path: '/test/social/popup-mobile-comments',
        component: () => import('@/module_social/components/post/mobile/PostComments'),
        name: "TestingPopupMobileComments"
    },
    {
        path: '/test/social/popup-desktop-comments',
        component: () => import('@/module_social/components/post/desktop/PostComments'),
        name: "TestingPopupDesktopComments"
    },
    {
        path: '/test/social/popup-post-menu',
        component: () => import('@/module_social/components/post/PostMenu'),
        name: "TestingPopupPostMenu"
    },
    {
        path: '/test/social/popup-create-post',
        component: () => import('@/module_social/components/post/CreatePost'),
        name: "TestingPopupCreatePost"
    },
    {
        path: '/test/social/popup-report-post',
        component: () => import('@/module_social/components/post/ReportPost'),
        name: "TestingPopupReportPost"
    },
    {
        path: '/test/social/popup-report-comment',
        component: () => import('@/module_social/components/post/ReportComment'),
        name: "TestingPopupReportComment"
    },
    {
        path: '/test/social/popup-block-user',
        component: () => import('@/module_social/components/user/BlockUser'),
        name: "TestingPopupBlockUser"
    },
    {
        path: '/test/social/user-profile',
        component: () => import('@/module_social/views/SocialUser'),
        name: "TestingUserProfile"
    },
    {
        path: '/test/social/hashtag',
        component: () => import('@/module_social/views/SocialHashtag'),
        name: "TestingHashtag"
    },
    {
        path: '/test/gif-loading',
        component: () => import('@/module_user/components/workout/LoadingModelVote'),
        name: "TestingLoadingModelVote"
    },
];

export default routes;

export function requireAuth(to, from, next) {
    if (localStorage.getItem("token") == null) {
        next("/ef/sign-in");
    }
        // else if (store.state.userInfo && !store.state.userInfo.passwordChanged && to.path.indexOf('change-password') == -1) {
        //   next("/change-password");
        // }
        // else if (store.state.userInfo & !store.state.userInfo.goalType) {
        //   next("/profile");
    // }
    else {
        next();
    }
}

function isAnonymous() {
    if (store.state.userInfo) {
        return store.state.userInfo.isAnonymousUser;
    } else {
        return true;
    }
}

function isMobile() {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    return isAndroid || isiOS;
}

export async function checkUserLogin(to, from, next) {

    const localuserInfo = JSON.parse(localStorage.getItem("userInfo"));
    const isUserInfoNotAvailable = (!localuserInfo || (localuserInfo && localuserInfo.length === 0) || Object.entries(localuserInfo).length === 0);
    // Pages that require user-data for direct access by link
    const directLinkPages = ['Home', 'Trainer Profile', 'workout', 'SignIn', 'SessionIDSignIn', 'SignUp', 'workout Mobile'];

    // Check for user-data in web-storage. if not, create a Anonymous user
    if (isUserInfoNotAvailable) {
        let localuserInfo = defaultUser[0];
        store.dispatch('saveAnonymousUser', localuserInfo).then(() => {
            // console.log("token created");
        });
        if (!directLinkPages.includes(to.name)) {
            return next({path: '/home'});
        }
    }

    else {

        /**
         * This array includes pages which user can't visit when he is logged in eg. sign-in & sign-up page
         * */
        const nonLoggedInPages = ['SignIn', 'SignUp'];

        /**
         * This array includes pages which user can only visit once he is logged in
         * */
        const loggedInPages = ['User Progress', 'Complete Profile'];

        /**
         * This array includes pages which only corp user can visit
         * */
        const corpLoginPages = ['leaderboard', 'CorporateDashboard'];

        // const mobilePages = ['workout'];

        // if (isMobile()) {
        //   if (mobilePages.includes(to.name)) {
        //     next(to.fullPath.replace("workout", "workout-mobile"));
        //     return;
        //   }
        // }

        if (!isAnonymous()) {
            if (nonLoggedInPages.includes(to.name)) {
                next("/");
                return;
            }
            if (corpLoginPages.includes(to.name) && !store.state.userInfo.corporate) {
                next("/");
                return;
            }
        }
        else {
            if (loggedInPages.includes(to.name) || corpLoginPages.includes(to.name)) {
                next("/");
                return;
            }
        }
    }
    next();
}

function getRedirectTo() {
    if (!isAnonymous()) {
        return store.state.defaultLandingPage;
    }
    return '/home';
}


